import { Dropdown } from "antd";
import React from "react";

// eslint-disable-next-line no-unused-vars
const TmsHeaderDropdown = ({ overlayClassName: cls, ...restProps }) => (
  <Dropdown {...restProps} />
);

export default TmsHeaderDropdown;
